var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('e-chart',{staticClass:"event-stack-chart",attrs:{"options":_vm.chartOptions,"autoresize":""}}):(_vm.loaded)?_c('div'):_c('SpinnerCmpt',{staticClass:"ml-5"})}
var staticRenderFns = []

export { render, staticRenderFns }